// Function index:
//   HexState — locally-edited hex row (q, r, terrain, name, description, lore).
//   TERRAINS — palette of supported terrain keys + their fill colour.
//   colorFor(terrain) — hex fill colour for a terrain key.
//   key(q, r) — stable string key for a (q, r) pair.
//   escHtml(s) — HTML-escape a string for innerHTML interpolation.

export interface HexState {
  q: number;
  r: number;
  terrain: string;
  name: string | null;
  description: string;
  lore: string;
}

export const TERRAINS: Array<{ key: string; color: number }> = [
  { key: 'grass',    color: 0x4a7a3a },
  { key: 'forest',   color: 0x2d5a2d },
  { key: 'hill',     color: 0x7a6b3a },
  { key: 'mountain', color: 0x6a6a6a },
  { key: 'water',    color: 0x2a5a8a },
  { key: 'desert',   color: 0xb8a06a },
  { key: 'unknown',  color: 0x222222 },
];

export const colorFor = (terrain: string): number =>
  TERRAINS.find((t) => t.key === terrain)?.color ?? 0x222222;

export function key(q: number, r: number): string { return `${q},${r}`; }

export function escHtml(s: string): string {
  return s.replace(/[&<>"']/g, (c) => ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]!));
}
